import { downgradeComponent } from '@angular/upgrade/static';
import { downgradedAngularModule } from 'src/ajs-app/app';
import { CrmDisplayFieldComponent } from './shared/crm-display-field/crm-display-field.component.ts';
import { SalesforceInteractionsComponent } from './shared/salesforce-interactions/salesforce-interactions.component.ts';
import { ZendeskInteractionsComponent } from './shared/zendesk-interactions/zendesk-interactions.component.ts';

downgradedAngularModule
  .directive('angularCrmDisplayField', downgradeComponent({ component: CrmDisplayFieldComponent }))
  .directive('angularSalesforceInteractions', downgradeComponent({ component: SalesforceInteractionsComponent }))
  .directive('angularZendeskInteractions', downgradeComponent({ component: ZendeskInteractionsComponent }))
  ;

